const SAME_TAB_ON_MOBILE = ['carestream2']

export default {
  async open(request, { mobile = false } = {}) {
    const windowReference = mobile ? null : window.open('', '_blank')

    try {
      const { data } = await request
      if (!data.url) {
        const error = new Error('PACS - URL inválida')
        error.invalidURL = true
        throw error
      }

      if (mobile && SAME_TAB_ON_MOBILE.includes(data.tipo_pacs)) {
        if (windowReference) windowReference.close()
        window.location.href = data.url
      } else  if (windowReference) {
        windowReference.location = data.url
      } else {
        // Mobile ou popup bloqueado: abre na mesma aba
        window.location.href = data.url
      } 
    } catch (error) {
      if (windowReference) windowReference.close()
      throw error
    }
  },
}
